import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';

const styles = (theme: Theme) => {
    const borderColor = theme.palette.type === 'light' ? theme.palette.grey[300] : theme.palette.grey[600];
    const color = theme.palette.type === 'light' ? theme.palette.grey[600] : theme.palette.grey[300];

    return createStyles({
        root: {
            color,
            borderColor,
            borderLeftWidth: 8,
            borderRadius: theme.shape.borderRadius,
            borderStyle: 'solid',
            borderWidth: 0,
            display: 'flex',
            padding: '6px 16px',
        },
        colorPrimary: {
            color: theme.palette.primary.main,
            borderColor: theme.palette.primary.main,
        },
        colorSecondary: {
            color: theme.palette.secondary.main,
            borderColor: theme.palette.secondary.main,
        },
        colorSuccess: {
            color: theme.palette.success.main,
            borderColor: theme.palette.success.main,
        },
        colorInfo: {
            color: theme.palette.info.main,
            borderColor: theme.palette.info.main,
        },
        colorWarning: {
            color: theme.palette.warning.main,
            borderColor: theme.palette.warning.main,
        },
        colorError: {
            color: theme.palette.error.main,
            borderColor: theme.palette.error.main,
        },
    });
};

export default makeStyles(styles, { name: 'MuiCallout' });
